<template>
    <div class="container-fluid">
        <Breadcrumb title="Create Offer" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit Offer #' + id" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <OfferForm :id="id" @hidePreloader="hidePreloader"></OfferForm>
                        <div class="alert alert-info">
                            <h4 class="alert-heading"><i class="fas fa-info"></i> Postback Info</h4>
                            <span>
                                Paste this url into offer
                                provider profile in specific settings to track conversions of this
                                offer. You can replace {cid} and {sum} if offer provider
                                uses another tags.
                            </span>
                            <h5 class="alert-heading mt-2">http://some-relay-ip/tracking/postback/v2/{cid}/{sum}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import OfferForm from './forms/OfferForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'Offer',
        props: ['id'],
        components: {
            Preloader, OfferForm, Breadcrumb
        },
        data() {
            return {
                loading: false,
                postbackUrl: ''
            }
        },
        mounted() {
            if (this.id) {
                this.loading = true;
            }
        },
        methods: {
            hidePreloader(value) {
                this.loading = !value
            }
        }
    }
</script>

<style scoped>

</style>
